import { render, staticRenderFns } from "./Macbook.vue?vue&type=template&id=63d50ba3&scoped=true"
import script from "./Macbook.vue?vue&type=script&lang=js"
export * from "./Macbook.vue?vue&type=script&lang=js"
import style0 from "./Macbook.vue?vue&type=style&index=0&id=63d50ba3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d50ba3",
  null
  
)

export default component.exports